<template>
  <b-card>
    <validation-observer
      ref="form"
      v-slot="{ handleSubmit }"
    >
      <b-row class="mb-1">
        <b-col cols="3">
          {{ $t('usersettings.paymentMethod') }}
        </b-col>
        <b-col cols="9">
          <b-form-select
            v-model="payment_method"
          >
            <b-form-select-option
              v-for="(option, idx) in paymentMethodOptions"
              :key="idx"
              :value="option.value"
            >
              {{ option.label }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="3">
          {{ $t('usersettings.accountHolder') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.accountHolder')"
            vid="account_holder"
            rules="required|min:3|max:100"
          >
            <b-form-input
              v-model="account_holder"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('usersettings.accountHolder')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row
        v-show="
          payment_method === allowMethods.PAYMENT_METHOD_PAYPAL
        "
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('pages.email') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.email')"
            vid="email"
            :rules="
              payment_method ===
                allowMethods.PAYMENT_METHOD_PAYPAL
                ? {
                  required: true,
                  email: true,
                  min: 3,
                  max: 100,
                }
                : ''
            "
          >
            <b-form-input
              v-model="email"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('pages.email')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row
        v-show="
          payment_method ===
            allowMethods.PAYMENT_METHOD_ACH
        "
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('usersettings.accountNumber') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.accountNumber')"
            vid="account_number"
            :rules="
              payment_method ===
                allowMethods.PAYMENT_METHOD_ACH
                ? { required: true, min: 3, max: 100 }
                : ''
            "
          >
            <b-form-input
              v-model="account_number"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('usersettings.accountNumber')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row
        v-show="
          payment_method ===
            allowMethods.PAYMENT_METHOD_ACH
        "
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('usersettings.routingNumber') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.routingNumber')"
            vid="routing_number"
            :rules="
              payment_method ===
                allowMethods.PAYMENT_METHOD_ACH
                ? { required: true, min: 3, max: 100 }
                : ''
            "
          >
            <b-form-input
              v-model="routing_number"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('usersettings.routingNumber')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row
        v-show="
          payment_method ===
            allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER
        "
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('usersettings.accountNumber') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            vid="account_number"
            :name="$t('usersettings.accountNumber')"
            :rules="
              payment_method ===
                allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER
                ? { required: true, min: 3, max: 100 }
                : ''
            "
          >
            <b-form-input
              v-model="account_number"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('usersettings.accountNumber')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row
        v-show="
          payment_method ===
            allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER
        "
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('usersettings.swift') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            vid="swift"
            :name="$t('usersettings.swift')"
            :rules="
              payment_method === allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER
                ? { required: true, min: 3, max: 100 }
                : ''
            "
          >
            <b-form-input
              v-model="swift"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="$t('usersettings.swift')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col
          cols="9"
          offset="3"
        >
          <b-form-checkbox
            id="vatNotApplicableCheckbox"
            v-model="is_vat_not_applicable"
          >
            {{ $t('usersettings.notApplicableForVat') }}
          </b-form-checkbox>
          <small class="text-muted">
            {{ $t('usersettings.vatNotApplicableHint') }}
          </small>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="3">
          {{ $t('usersettings.vatNumber') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.vatNumber')"
            vid="vat_number"
            :rules="is_vat_not_applicable ? 'min:3|max:50' : 'required|min:3|max:50'"
          >
            <b-form-input
              v-model="vat_number"
              :state="
                isValidated && errors.length > 0 ? false : null
              "
              :placeholder="is_vat_not_applicable ? $t('usersettings.vatNumberOptional') : $t('usersettings.vatNumber')"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="3">
          {{ $t('usersettings.vatPercentage') }}
        </b-col>
        <b-col cols="9">
          <b-form-input
            :value="profile.vat_percentage"
            readonly
            disabled
          />
        </b-col>
      </b-row>
      <b-row
        class="mb-1"
      >
        <b-col cols="3">
          {{ $t('usersettings.currency') }}
        </b-col>
        <b-col cols="9">
          <b-form-radio-group
            id="radio-group-1"
            v-model="currency"
            :options="[
              {
                value: '$',
                text: 'USD',
              },
              // {
              //   value: '€',
              //   text: 'EURO',
              // }
            ]"
            name="curreny-options"
          />
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="3">
          {{ $t('usersettings.minimumPayment') }}
        </b-col>
        <b-col cols="9">
          <validation-provider
            #default="{ errors }"
            :name="$t('usersettings.minimumPayment')"
            vid="minimum_payment"
            rules="greaterThanZero"
          >
            <minimum-payment
              v-if="alreadyMounted"
              v-model="minimum_payment"
              name="minimum_payment"
              :currency="currency"
              :payment-type="payment_method"
            />
            <small
              v-if="isValidated && errors.length > 0"
              class="text-danger"
            >{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="
              isValidated = true;
              handleSubmit(submit);
            "
          >
            {{ $t('apps.saveChanges') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            @click.prevent="reset()"
          >
            {{ $t('usersettings.reset') }}
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import i18n from '@/libs/i18n'

import Ripple from 'vue-ripple-directive'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'
import MinimumPayment from './MinimumPayment.vue'

extend('greaterThanZero', {
  computesRequired: true,
  validate: value => value > 0,
  message: (field, parameters) => i18n.t('usersettings.minimumPaymenHasToBeGreaterThanZero', { ...parameters, _field_: field }),
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    MinimumPayment,
  },
  directives: {
    Ripple,
  },
  props: ['profile'],
  data() {
    return {
      payment_method: 1,
      email: '',
      routing_number: '',
      account_number: '',
      swift: '',
      bitcoin_address: '',
      currency: '$',
      minimum_payment: 100,
      account_holder: '',
      vat_number: '',
      is_vat_not_applicable: false,
      // Options
      allowMethods: {
        // PAYMENT_METHOD_PAYPAL: 1,
        PAYMENT_METHOD_ACH: 2,
        PAYMENT_METHOD_INTENATIONAL_TRANSFER: 3,
      },
      alreadyMounted: false,
      isValidated: false,
    }
  },
  computed: {
    activeUserInfo() {
      return this.profile
    },
    paymentMethodOptions() {
      return [
        {
          label: this.$t('usersettings.ach'),
          value: this.allowMethods.PAYMENT_METHOD_ACH,
        },
        {
          label: this.$t('usersettings.internationalTransfer'),
          value: this.allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER,
        },
      ]
    },
  },
  mounted() {
    this.fillOutUserData()
    this.alreadyMounted = true
  },
  methods: {
    submit() {
      this.showLoading()
      this.$http
        .put(
          '/api/profile-settings/update-payment-details',
          this.getPostData(),
        )
        .then(response => {
          this.$store.dispatch(
            'auth/updateProfile',
            response.data.profile,
          )
          this.$emit('refresh-profile')
          this.alertSuccess(response.data.message)
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('usersettings.paymentDetailsUpdateFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    fillOutUserData() {
      if (Object.keys(this.activeUserInfo).includes('payment_method')) {
        const filterMethod = this.paymentMethodOptions.filter(
          option => option.value === this.activeUserInfo.payment_method,
        )
        if (filterMethod.length === 1) {
          this.payment_method = filterMethod[0].value
        } else {
          this.payment_method = this.paymentMethodOptions[0].value
        }
      }
      if (Object.keys(this.activeUserInfo).includes('payment_details')) {
        if (
          typeof this.activeUserInfo.payment_details === 'object'
            && this.activeUserInfo.payment_details !== null
        ) {
          Object.keys(this.activeUserInfo.payment_details).forEach(
            key => {
              if (Object.keys(this.$data).includes(key)) {
                this.$data[key] = this.activeUserInfo.payment_details[key]
              }
            },
          )
        }
      }
      this.vat_number = this.activeUserInfo.vat_number || ''
      this.is_vat_not_applicable = !!this.activeUserInfo.is_vat_not_applicable
      this.minimum_payment = this.profile.minimum_payment
      this.generateValidateFormResult()
    },
    reset() {
      this.isValidated = false
      this.fillOutUserData()
    },
    getPostData() {
      let postData = {}
      if (
        this.payment_method
          === this.allowMethods.PAYMENT_METHOD_PAYPAL
      ) {
        postData = {
          payment_method: this.allowMethods.PAYMENT_METHOD_PAYPAL,
          payment_details: JSON.stringify({
            account_holder: this.account_holder,
            email: this.email,
            currency: this.currency,
          }),
        }
      } else if (
        this.payment_method
          === this.allowMethods.PAYMENT_METHOD_ACH
      ) {
        postData = {
          payment_method:
          this.allowMethods.PAYMENT_METHOD_ACH,
          payment_details: JSON.stringify({
            account_holder: this.account_holder,
            account_number: this.account_number,
            routing_number: this.routing_number,
            currency: this.currency,
          }),
        }
      } else if (
        this.payment_method
          === this.allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER
      ) {
        postData = {
          payment_method:
          this.allowMethods.PAYMENT_METHOD_INTENATIONAL_TRANSFER,
          payment_details: JSON.stringify({
            account_holder: this.account_holder,
            account_number: this.account_number,
            swift: this.swift,
            currency: this.currency,
          }),
        }
      }
      postData.minimum_payment = this.minimum_payment
      postData.vat_number = this.vat_number
      postData.is_vat_not_applicable = this.is_vat_not_applicable
      return postData
    },
    generateValidateFormResult() {
    },
  },
}
</script>
